import {
    useEffect,
    useState,
} from 'react';
import {
    changeToDealerCode,
    Dealer,
    fetchDealers,
} from './dealerGateway';

export interface GetDealersHookResponse {
    loading: boolean;
    error: boolean;
    dealers: Dealer[];
}

export function useGetDealers(dealersEndpoint: string): GetDealersHookResponse {
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    const [dealers, setDealers] = useState([] as Dealer[]);

    useEffect(() => {
        const fetch = async (): Promise<void> => {
            try {
                setDealers(await fetchDealers(dealersEndpoint));
            } catch (e) {
                setError(true);
            }
            setLoading(false);
        };
        void fetch();
    }, []);

    return { loading, error, dealers };
}

export function useChangeDealer(changeDealerEndpoint: string, dealerCode: string): { loading: boolean; error: boolean } {
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);

    useEffect(() => {
        const fetch = async (): Promise<void> => {
            try {
                await changeToDealerCode(changeDealerEndpoint, dealerCode);
            } catch (e) {
                setError(true);
            }
            setLoading(false);
        };
        void fetch();
    }, []);

    return { loading, error };
}
